import * as React from 'react'
import { Col, Card, Row, Divider } from 'antd'
interface Props {
  image?: JSX.Element
  header?: JSX.Element
  body: JSX.Element
  footer: JSX.Element
}

export const CardWrapper = (props: Props) => {
  const { image, header, body, footer } = props

  return (
    <Col xxl={8} xl={8} lg={12} md={24} sm={24} xs={24} className='d-flex'>
      <div className='pr-3 pb-3' style={{ display: 'flex', flexGrow: 1 }}>
        <Card bordered={false} style={{ flexGrow: 1 }} bodyStyle={{ flexGrow: 1, padding: '1rem' }}>
          <Row>
            {image && (
              <Col span={4} className='mr-2'>
                {image}
              </Col>
            )}

            <Col span={19}>
              <header>{header}</header>

              <main>{body}</main>

              <Divider className='mt-2 mb-2' />

              <footer>{footer}</footer>
            </Col>
          </Row>
        </Card>
      </div>
    </Col>
  )
}
